module.exports = __webpack_public_path__ + "static/joc_09-65fa1ee178ba778778971560d1325a54.jpg";